'use strict';

const { markSupplierReady, openSupplierReadyGate } = require('public/js/lib/supplier-ready');
const { waitForAttribution } = require('public/js/lib/session-attribution');
const { waitForCsrf } = require('public/js/lib/csrf/utils');

/**
 * Starts supplier resolution for a page load and settles the gate once it finishes.
 *
 * Lives here rather than in `supplier-ready.js` because it needs `waitForCsrf`, and
 * `csrf/utils.js` already requires `supplier-ready.js` for the endpoint it exempts from deferral.
 * Closing that loop would hand one of the two a partially initialised module, leaving the exemption
 * undefined and deadlocking every page until the bootstrap timeout.
 *
 * @param {{ isIframedPage: boolean, resolveLocation: function(): Promise<void> }} options
 * @returns {Promise<void>} Resolves once the gate has been settled.
 */
function initSupplierResolution({ isIframedPage, resolveLocation }) {
	// Iframed plugin pages never resolve a supplier themselves; the parent frame does it for them.
	if (isIframedPage) {
		markSupplierReady();

		return Promise.resolve();
	}

	// Sequenced after the CSRF token and the attribution post: the session blob is rewritten
	// wholesale, so an earlier lookup would erase the acquisition source. Settled on failure too,
	// so a failed lookup releases the burst instead of stranding it until the timeout.
	return waitForCsrf()
		.then(waitForAttribution)
		.then(resolveLocation)
		.then(markSupplierReady, markSupplierReady);
}

module.exports = {
	initSupplierResolution,
	// Re-exported so entry points take a single dependency for the whole page-load concern, the way
	// they already do for `initCsrfBootstrap`.
	openSupplierReadyGate,
};
